import { Component, OnInit, ViewChild } from '@angular/core';
import { Globals } from '../../_models/globals';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiIntegration } from '../../_services/api.integration';
import { environment } from '../../../environments/environment';
import { Items } from '../../_models/items';
import * as _ from "lodash";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-create-invoice',
  templateUrl: './create-invoice.component.html',
  styleUrls: ['./create-invoice.component.css']
})
export class CreateInvoiceComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  itemLinesError: string;
  statusText4: string;
  statusText5: string;
  quantityError: string;
  accountOwners: any;
  invoiceAmount: any;
  quantity: any;
  invoiceList: any[];
  items: any[] = [];
  itemLine: Items = {};
  itemLines: Items[] = [];
  item: Items = {
    config: "",
    id: 0,
    //cost :0
  };
  accountOwner: string;
  parent: string;
  invoiceNumber: string = '';
  invoiceDate: string = '';
  itemType: string = '';
  itemTypeError: string;
  addItemModalOpen: boolean = false;
  itemIndex: number;
  gstNumber: any;
  gstNumberCorp: any;
  addressState: any;
  accountOwnerData: any;
  referenceNumber: any;
  period: string;
  subTotal: any = 0.00;
  igstTotal: any = 0.00;
  cgstTotal: any = 0.00;
  sgstTotal: any = 0.00;
  total: any = 0.00;

  constructor(private alertService: AlertService, private g: Globals, private api: ApiIntegration, private http: HttpClient, private router: Router, public route: ActivatedRoute) {
    this.g.page = "Create an Invoice";
    this.api.getAccountOwners("1", "ACTIVE").subscribe((data: any) => {
      this.accountOwners = data.getAccountOwnersResponses;
    },
      err => {
        console.log(err);
      });
    this.getValue();
  }

  getValue() {
    this.api.getValues("1", "ITEM_CODE", "INVOICE_TYPE", "ITEM_CODE").subscribe((data: any) => {
      this.items = data.tripleSetConfigDTOS;
    },
      err => {
        this.alertService.error('Error', err);
      });
  }

  openItemModal() {
    this.addItemModalOpen = true;
  }

  closeModal() {
    this.addItemModalOpen = false;
    this.itemType = "";
  }

  dateBlur() {
    this.statusText3 = "";
    if (!this.invoiceDate) {
      this.statusText3 = 'Please select Invoice date';
    }
  }

  accountOwnerBlur() {
    this.statusText1 = "";
    if (!this.accountOwner) {
      this.statusText1 = 'Please select account owner';
    }
  }

  accountOwnerDetails() {
    this.api.getBillingAddressById().subscribe((data: any) => {
      this.accountOwnerData = data;
      this.addressState = data.state;
      this.gstNumber = data.gstNumber;
    },
      err => {
        console.log(err);
      });
  }

  addLineItem() {
    this.itemTypeError = "";

    if (!this.itemType) {
      this.itemTypeError = 'Please enter item type';
      return false
    }
    let body = {
      "child": "ITEM_CODE",
      "config": this.itemType,
      "control": "ITEM_CODE",
      "organizationId": 1,
      "parent": "INVOICE_TYPE"
    };
    this.g.loaderDisplay = "display";
    this.api.updateItemValue(body).subscribe((data: any) => {
      if (data['code'] === '200') {
        let attachItem = {
          "id": data['id'],
          "control": data['control'],
          "parent": data['parent'],
          "child": data['child'],
          "config": data['config'],
          "orderBy": data['orderBy'],
          "organizationId": data['organizationId']
        };
        this.items.push(attachItem);
        this.item = attachItem;
        this.alertService.success('Item', "Created Successfully");
        this.g.loaderDisplay = "";
        this.addItemModalOpen = false;
        this.itemType = "";
        this.itemTypeError = "";
        this.closebutton.nativeElement.click();
        this.getValue();
      }

    },
      err => {
        this.g.loaderDisplay = '';
        this.alertService.error('Error', err);
      });
  }

  addSelectedItem() {
    this.statusText4 = "";
    this.statusText5 = "";
    this.quantityError = "";

    if (this.item === null || this.item === undefined) {
      this.statusText4 = 'Please enter item';
    }
    if (this.invoiceAmount == '' || this.invoiceAmount === null || this.invoiceAmount === undefined || this.invoiceAmount === 'undefined') {
      this.statusText5 = 'Please enter Invoice Amount';
    }
    if (!this.quantity) {
      this.quantityError = 'Please enter quantity';
    }
    if (this.statusText4 != "" || this.statusText5 != "" || this.quantityError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    if (this.item != null && this.item.id !== null && this.item.id !== 0) {
      this.itemLine.id = this.item.id;
      this.itemLine.itemCode = this.item.config;
      this.itemLine.invoiceAmount = this.invoiceAmount;
      this.itemLine.quantity = this.quantity;
      this.itemLine.multiplication = Number(this.invoiceAmount) * Number(this.quantity);

      this.itemLines.push(_.cloneDeep(this.itemLine));
      this.item = null;
      this.invoiceAmount = null;
      this.quantity = null;
      this.getSubTotal();
    }
  }

  customSearchAccountOwner(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.ownerName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }

  removeItem(i) {
    console.log(i);
    let index = this.itemLines.indexOf(i);
    this.itemLines.splice(index, 1);
    this.getSubTotal();
  }

  ngOnInit() {
  }

  gstCal() {
    this.gstNumberCorp = this.gstNumber ? this.gstNumber.substr(0, 2) : this.gstNumber;
    console.log(this.gstNumber);
    console.log(this.gstNumberCorp);
  }

  getSubTotal() {
    this.gstCal();
    let total = 0.00;
    this.itemLines.forEach((t) => {
      total = total + Number(t.multiplication);
    });
    this.subTotal = total.toFixed(2);
    this.igstTotal = ((total * 18) / 100).toFixed(2);
    this.cgstTotal = ((total * 9) / 100).toFixed(2);
    this.sgstTotal = ((total * 9) / 100).toFixed(2);
    if ((this.gstNumberCorp !== null && this.gstNumberCorp == '36') || (this.gstNumberCorp == null && this.addressState === 'telangana')) {
      this.total = Number(this.subTotal) + Number(this.cgstTotal) + Number(this.sgstTotal);
    } else {
      this.total = Number(this.subTotal) + Number(this.igstTotal);
    }
    this.total = (this.total).toFixed(2);
    return total.toFixed(2);
  }

  submitItem() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    //this.statusText2 = "";
    this.statusText3 = "";
    this.itemLinesError = "";

    if (this.accountOwner == '' || this.accountOwner === null || this.accountOwner === undefined || this.accountOwner === 'undefined') {
      this.statusText1 = 'Please enter account owner';
    }
    /*     if (this.invoiceNumber == '' || this.invoiceNumber === null || this.invoiceNumber === undefined || this.invoiceNumber === 'undefined') {
          this.statusText2 = 'Please enter Invoice number';
        } */
    if (this.invoiceDate == '' || this.invoiceDate === null || this.invoiceDate === undefined || this.invoiceDate === 'undefined') {
      this.statusText3 = 'Please enter Invoice date';
    }
    if (this.itemLines.length === 0) {
      this.itemLinesError = 'Please select at least one item';
    }
    if (this.statusText1 != "" || this.statusText3 != "" || this.itemLinesError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createManualInvoice', {
      "accountOwnerId": this.accountOwner,
      "invoiceType": 'MANUAL',
      "linesRequests": this.itemLines,
      "organizationId": 1,
      "paymentStatus": "UNPAID",
      "invoiceDate": this.invoiceDate,
      //"invoiceNumber": this.invoiceNumber,
      "refHeaderNumber": this.referenceNumber,
      "servicePeriod": this.period
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Invoice', 'Created Successfully');
          this.router.navigate(['/admin/adminInvoice']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      }, (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });
  }
}

//"addressState" : "Telangana"
